<script lang="ts">
	import { track } from '$lib/utils/track'
	import Button from '$lib/components/buttons/Button.svelte'
	import { goto } from '$app/navigation'

	function applyForGuide() {
		track('Apply to Guide Clicked')
		goto('/store')
	}
</script>

<div class="bg-white pt-12 pb-24 sm:pt-24 sm:pb-32 lg:pb-36" data-testid="Pricing">
	<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
		<div class="mx-auto max-w-2xl text-center">
			<h2 class="text-3xl font-bold tracking-tight text-black sm:text-4xl">
				Transparent Commission,
				<br />
				Fair Earnings
			</h2>
			<p class="mt-6 text-lg leading-8 text-brand-gray-5">
				Keep more of what you earn with straightforward pricing
			</p>
		</div>
		<div
			class="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-brand-gray-2 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none"
		>
			<div class="p-8 sm:p-10 lg:flex-auto">
				<p class="mt-6 text-base text-pretty leading-7 text-brand-gray-5">
					We believe in rewarding your creativity and hard work. That is why we have adopted a
					simple commission pricing model. For every sale you make, you take 80% of the comission,
					ensuring that the most always goes back into your pocket. It is your passion, your
					content, and your revenue. We are here to facilitate and celebrate your success.
				</p>
				<div class="mt-10 flex items-center gap-x-4">
					<div class="flex-none text-sm font-semibold leading-6 text-black">Included</div>
					<div class="h-px flex-auto bg-brand-gray-0"></div>
				</div>
				<ul
					role="list"
					class="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-brand-gray-5 sm:grid-cols-2 sm:gap-6"
				>
					<li class="flex gap-x-3">
						<svg
							class="h-6 w-5 flex-none text-brand-primary"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
						>
							<path
								fill-rule="evenodd"
								d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
								clip-rule="evenodd"
							/>
						</svg>
						Free to List
					</li>
					<li class="flex gap-x-3">
						<svg
							class="h-6 w-5 flex-none text-brand-primary"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
						>
							<path
								fill-rule="evenodd"
								d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
								clip-rule="evenodd"
							/>
						</svg>
						Use Existing Content
					</li>
					<li class="flex gap-x-3">
						<svg
							class="h-6 w-5 flex-none text-brand-primary"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
						>
							<path
								fill-rule="evenodd"
								d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
								clip-rule="evenodd"
							/>
						</svg>
						Peer Network
					</li>
					<li class="flex gap-x-3">
						<svg
							class="h-6 w-5 flex-none text-brand-primary"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
						>
							<path
								fill-rule="evenodd"
								d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
								clip-rule="evenodd"
							/>
						</svg>
						Customer Support
					</li>
				</ul>
			</div>
			<div class="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
				<div
					class="rounded-2xl bg-grey-lt py-10 text-center ring-1 ring-inset ring-brand-gray-6/5 lg:flex lg:flex-col lg:justify-center lg:py-16"
				>
					<div class="mx-auto max-w-xs px-8">
						<p class="text-2xl font-semibold text-brand-gray-50">Maximize Your Earning Potential</p>
						<p class="mt-6 flex flex-col justify-center items-center gap-x-2">
							<span class="text-5xl font-bold tracking-tight text-brand-gray-6">80%</span>
							<span class="text-sm font-semibold leading-6 text-brand-gray-5"
								>of the published price</span
							>
						</p>
						<Button theme="dark" onclick={applyForGuide} class="mt-10 mx-auto"
							>Set Up Your Store</Button
						>
						<p class="mt-6 text-xs leading-5 text-brand-gray-4">Airheart covers all fees</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
